<template>
  <div class="auth-wrapper auth-v2 fullscreen">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <img :src="$i18n.locale === 'en' ? '//soustitreur.com/images/logo/logo-closedCaptioner.svg' : '//soustitreur.com/images/logo/logo.png'" style="height:220px;">
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <!-- Locale -->
          <div
            class="horizontal-layout"
            style="height:inherit"
          >
            <div class="navbar-container d-flex content align-items-center">
              <b-navbar-nav class="nav align-items-center ml-auto">
                <locale />
              </b-navbar-nav>
            </div>
          </div>
          <!-- /Locale -->
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
            {{ $t("Sign in") }}
          </b-card-title>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                :label="$t('Email')"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="john@example.com"
                    ref="refEmail"
                    @keydown.tab.prevent="focusInputPassword()"
                  />
                  <small class="text-danger" v-if="errors.length">{{ Object.keys(failedRules)[0] ? $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':'Email'}) : errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">{{ $t("Password") }}</label>
                  <b-link :to="{name:'ForgotPassword'}">
                    <small>{{ $t("Forgot password?") }}</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      :placeholder=" $t('Type your password')"
                      ref="refPassword"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':'Email'}) }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  {{ $t("Remember Me") }}
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="success"
                block
                :disabled="invalid"
              >
              <b-spinner small v-if="isloading"/>
                {{ $t("Sign in") }}
              </b-button>
            </b-form>
          </validation-observer>

          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text">
              {{ $t("or sign in with") }}
            </div>
          </div>

          <!-- social buttons -->
            <b-button
              variant="tumblr"
              block
              @click="$router.push({name:'LoginWithOTP'})"
            >
            {{ $t("Connect without password") }}
            </b-button>

          <!--
            <b-button variant="reddit" block>
              <a href="#">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg>
                  Google
              </a>
            </b-button>-->
          
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BForm, BButton, BAlert, VBTooltip, BNavbarNav, BNavbar, BSpinner
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import Locale from '@/components/header/Locale.vue'
import Apicall from '@/libs/api-call' 

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BForm,
    BButton,
    BAlert,
    BSpinner,
    BNavbar,
    BNavbarNav,
    ValidationProvider,
    ValidationObserver,
    Locale,
    ToastificationContent,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      // validation rules
      required,
      email,
      isloading: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  mounted() {
    this.checkBearerToken();
    this.setLocale();
    this.getGeoInfo();
  },
  methods: {
    checkBearerToken() {
      const api = new Apicall();
      api.isLoggedIn().then((response) => {
        if (response === true) {
          this.$router.push({name:'UserMyOrders'});
        }
      });
    },
    getGeoInfo() {
      if (Object.keys(this.$store.state.geoinfos).length === 0) {
        this.$http.get('https://gapps.soustitreur.com/').then(res => {
          this.$store.state.geoinfos = res.data;
        })
      }
    },
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          const api = new Apicall()
          this.isloading = true;
          api.login(this.userEmail, this.password).then((response) => {
              if (response.status === 'OK') {
                if (response.language != null) {
                    let locale = response.language.toLowerCase().substring(0,2);
                    switch (locale) {
                        case 'fr':
                            this.$i18n.locale = 'fr';
                            window.localStorage.setItem('language', 'fr');
                            break;
                        default:
                            break;
                    }
                }
                this.$router.push({name:'UserMyOrders'})
                .then(() => {
                  const name = store.state.userData.fullName ? store.state.userData.fullName : store.state.userData.email;
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: this.$t('Welcome') + ` ${name}`,
                      icon: 'CoffeeIcon',
                      variant: 'success',
                    },
                  });
                });
              } else {
                  const errorData = {email: [this.$t(response.msg)]};
                  this.$refs.loginForm.setErrors(errorData);
                  this.$refs.refEmail.focus();
              }
              this.isloading = false;
          }).catch((response) => {
            const errorData = {email: [this.$t(response.msg)]}
              this.$refs.loginForm.setErrors(errorData)
          });
        }
      })
    },
    setLocale() {
      // set default language depend on host name
      switch (window.location.host) {
        case 'soustitreur.com':
          this.$i18n.locale = 'fr';
          break;
        default:
          this.$i18n.locale = 'en';
          break;
      }
    },
    focusInputPassword() {
      this.$refs.refPassword.focus();
    }
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.fullscreen {
  background-image: linear-gradient(90deg, #b6fdb2 0%, #b6fdb2 50%, #EBFFEB 100%);
}
html[dir=ltr] .content {
    margin-left: 0px;
}
</style>
